// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VzOF2","row":"styles_row__CiK3s","head":"styles_head__Y1DSM","column":"styles_column__hcbRy"};